import { IRootState } from '../reducer'
import { prefix } from './actions'

export const isLoading = (state: IRootState) => state[prefix].loadingArray.length > 0

export const list = (state: IRootState) => state[prefix].list

export const current = (state: IRootState) => state[prefix].current

export const events = (state: IRootState) => state[prefix].events
export const boardMembers = (state: IRootState) => state[prefix].boardMembers

export const commentary = (state: IRootState) => state[prefix].commentary
